<div class="modal-fullscreen" (sdClickOutside)="onClickOutside()" [style.maxWidth]="options().maxWidth">
  @if (options().title || !options().hideCloseButton) {
    @if (options().title) {
      <div class="modal-fullscreen__header">
        <h3 class="modal-fullscreen__title text-b1-m-900">{{ options().title }}</h3>
      </div>
    }

    @if (!options().hideCloseButton) {
      <button class="modal-fullscreen__close" (click)="onClose()">
        <sd-icon type="cross" class="icon-size-s icon-size-md-m icon-size-lg-l"></sd-icon>
      </button>
    }
  }

  <div class="modal-fullscreen__body">
    <ng-content></ng-content>
  </div>
</div>
